import apicaller from "@/utils/apicaller";
import api from "../../main.api";
import { cddRejectOnError } from "./cddResponse";

export default {
  getResponseCodes() {
    return apicaller.get(api.CDD.responseCodes);
  },
  getResponseCodeById(id) {
    return apicaller.get(`${api.CDD.responseCodes}/${id}`);
  },
  createResponseCode(payload) {
    return apicaller
      .post(`${api.CDD.responseCodes}/create`, payload)
      .then(cddRejectOnError);
  },
  updateResponseCode(payload) {
    return apicaller
      .post(`${api.CDD.responseCodes}/update`, payload)
      .then(cddRejectOnError);
  },
  deleteResponseCode(id) {
    return apicaller.post(`${api.CDD.responseCodes}/delete/${id}`, {});
  },
  getDecisions() {
    return apicaller.get(api.CDD.decisions);
  },
  saveDecisions(mappings) {
    return apicaller.post(api.CDD.decisions, mappings).then(cddRejectOnError);
  },
  getHistory(changeType, limit = 200) {
    return apicaller.get(api.CDD.decisionHistory, {
      params: { changeType, limit }
    });
  }
};
